module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/SS-icon-checkmark-cc93d5a85f87a3f3cbb5754b21d62f01.png";